import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import CatalogAsideMenu from 'rebook/apps/catalog/components/CatalogAsideMenu';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import { Niche } from 'rebook/apps/catalog/models';
import * as NicheBookListActions from 'rebook/apps/catalog/actions/NicheBookListActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';

import styles from './style.scss';


const paginateCountLong = 10;
const paginateCountShort = 18;

class NicheBookListView extends React.Component {
  constructor() {
    super();
    this.state = {
      isDisplayLongVersion: false,
    };
  }

  static fetchInitialDataForServer(match, store) {
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    return store.dispatch(NicheBookListActions.fetchInitialData(match, {}, paginateBy));
  }

  componentDidMount() {
    const { match, location } = this.props;
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    this.props.NicheBookListActions.fetchInitialData(match, location, paginateBy);
    setTimeout(function () {
      window.dataLayer.push({ event: 'optimize.context.activate' });
    }, 0);
  }


  componentWillReceiveProps(nextProps) {
    const { nicheSlug } = this.props.match.params;
    const { nicheSlug: newNicheSlug } = nextProps.match.params;

    if (nicheSlug !== newNicheSlug) {
      this.props.NicheBookListActions.resetData();
      this.props.NicheBookListActions.fetchInitialData(nextProps.match, nextProps.location);
    }
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.NicheBookListActions.fetchBookList({ pageNumber }, this.props.match);
  }

  onChangeOrderBy(orderBy) {
    this.props.NicheBookListActions.fetchBookList({ orderBy }, this.props.match);
  }

  onChangeSubscriptionType(subscriptionId) {
    this.props.NicheBookListActions.fetchBookList({ subscriptionId }, this.props.match);
  }

  onChangeBookType(bookType) {
    this.props.NicheBookListActions.fetchBookList({ bookType }, this.props.match);
  }

  onResetFilter(catalogBookType) {
    this.props.NicheBookListActions.fetchBookList({
      orderBy: 'popular',
      subscriptionId: catalogBookType === 'free' ? 0 : null,
      bookType: catalogBookType === 'audio' ? 'audio' : null,
    },
    this.props.match);
  }

  viewVersionToggler() {
    this.setState({ isDisplayLongVersion: !this.state.isDisplayLongVersion });
  }

  render() {
    const { books, orderBy, subscriptionId, pageNumber, lastPageNumber, bookType } = this.props.nicheBookList;
    const { niche: nicheObject } = this.props.nicheBookList;
    const { match } = this.props;
    const niche = nicheObject ? new Niche(nicheObject) : null;
    let headerTitle, headerBookCount;
    const isDisplayLongVersion = get(match, 'path', '').indexOf('/t/') !== -1;
    const { bookType: catalogBookType } = this.props.match.params;
    const booksPerSubscriptionCounter = get(niche, 'counters', { total: 0 });
    const titlesMapper = {
      free: {
        header: `Бесплатные книги в жанре «${get(niche, 'name', '')}»`,
        breadCrumbs: 'Бесплатные книги',
      },
      total: {
        header: `Все книги в жанре «${get(niche, 'name', '')}»`,
        breadCrumbs: 'Все книги',
      },
      audio: {
        header: `Все аудиокниги в жанре «${get(niche, 'name', '')}»`,
        breadCrumbs: 'Все аудиокниги',
      },
    };

    if (niche) {
      headerTitle = get(titlesMapper, `[${catalogBookType}].header`, titlesMapper.total.header);
      headerBookCount = booksPerSubscriptionCounter[catalogBookType] || booksPerSubscriptionCounter.books;
    }
    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Библиотека', url: '/catalog/' },
          { text: get(niche, 'name', ''), url: niche ? niche.getLink() : '' },
          {
            text: get(titlesMapper, `[${catalogBookType}].breadCrumbs`, titlesMapper.total.breadCrumbs),
            url: get(this, 'props.location', ''),
          },
        ]} />
        {niche
          ? (
            <CatalogHeader
              title={headerTitle}
              bookType={catalogBookType === 'audio' ? catalogBookType : 'text'}
              bookCount={headerBookCount} />
          )
          : <CatalogHeader />
        }
        <div className={styles.content}>
          <div className={styles.contentAside}>
            <CatalogAsideMenu
              items={get(nicheObject, 'genres', [])}
              urlPattern={(url) => (`/catalog/${niche.slug}/${url}`)}
              passState />
            {niche && (
              <CatalogAsideMenu
                items={[
                  {
                    ...niche,
                    name: `Все книги в жанре<br> ${niche.name}`,
                    active_book_count: get(niche, 'counters.books', 0),
                    slug: `/catalog/${niche.slug}/books/`,
                  },
                  {
                    ...niche,
                    name: `Бесплатные книги в жанре<br> ${niche.name}`,
                    active_book_count: get(niche, 'counters.free', 0),
                    slug: `/catalog/${niche.slug}/books/free/`,
                  },
                  {
                    ...niche,
                    name: `Aудиокниги в жанре<br> ${niche.name}`,
                    active_book_count: get(niche, 'counters.audio', 0),
                    slug: `/catalog/${niche.slug}/books/audio/`,
                  },
                ]}
                urlPattern={(slug) => (slug)}
                extraClassName={styles.allBooksLink} />
            )}
          </div>
          <div className={styles.contentMain}>
            <div className={styles.filters}>
              <CatalogFilter
                orderBy={orderBy}
                isSubscriptionEnabled={!(catalogBookType === 'audio' || catalogBookType === 'free')}
                subscriptionId={subscriptionId}
                bookType={bookType}
                isBookTypeEnabled={!(catalogBookType === 'audio' || catalogBookType === 'free')}
                isResultEmpty={books && books.length === 0}
                onChangeSubscription={(value) => this.onChangeSubscriptionType(value)}
                onChangeOrder={(value) => this.onChangeOrderBy(value)}
                onChangeBookType={((value) => this.onChangeBookType(value))}
                onResetFilter={(catalogBookType) => this.onResetFilter(catalogBookType)} />
            </div>
            {
              !books
                ? <BookList books={[...Array(6)]} maxColumns={3} />
                : (isDisplayLongVersion ? <BookList books={books} maxColumns={1} isDisplayLongVersion /> :
                  <BookList books={books} maxColumns={3} />)
            }
            {books && books.length === 0 && <EmptyFilterResult />}
            {lastPageNumber > 1 && (
              <ContextPagination
                extraClassName={styles.pagination}
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={pageNumber}
                lastPage={lastPageNumber} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

NicheBookListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      nicheSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    nicheBookList: state.nicheBookList,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    NicheBookListActions: bindActionCreators(NicheBookListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NicheBookListView);
